import React, { Component } from "react";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout.js";
import getConfig from "next/config";
import Loading from "@components/Loading";
import { getCategory, getSearch } from "@store/catalog/actions";
import CatalogList from "@containers/Catalog/List";
import { extractFiltersParams } from "@lib/filterUtil";
import ErrorPage from "@containers/ErrorPage";
import { getWebsiteAdminConfig } from "@store/app/actions";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

// TODO: MEGA FUCKING WARNING!!
// MAKE SURE TO KEEP THINGS IN SYNC AT THE MOMENT
// cauta/[[...filters]].js
// [urlKey]/cpl/[[...filters]].js

class List extends Component {
  constructor(props) {
    super(props);

    this.pageNamePrefix = `catalog`;

    this.state = {
      ready: false,
    };
  }

  static async getInitialProps(ctx) {
    const { reduxStore, query, asPath: urlAsPath, req, res } = ctx;
    let ready = null;

    let currentUrl = urlAsPath;

    if (req) {
      currentUrl = `${settings.baseUrl}${urlAsPath}`;
    }

    if (!reduxStore.getState().app.websiteAdminConfigs.featureFlagsWebsite) {
      await reduxStore.dispatch(
        getWebsiteAdminConfig({ code: "featureFlagsWebsite" })
      );
    }

    // TODO: We manually remove filtru slug from the router
    // because we have a catch all ([[...filters]]) route
    // Important: Some filters can be named "filtru"
    // URL: /accesorii-consumabile-electrocasnice-mari/cpl/filtru/tip-produs-8434/filtru/
    // query.filters: /filtru/tip-produs-8434/filtru/
    const queryFilters = query.filters || [];

    const filterPrefixIndex = queryFilters.findIndex(
      (queryFilter) => queryFilter === "filtru"
    );

    if (filterPrefixIndex === 0) {
      queryFilters.shift();
    }

    const extractedFiltersParams = extractFiltersParams(queryFilters);

    if (query.exclude_preselected) {
      extractedFiltersParams.excludePreselected =
        query.exclude_preselected.split(",");
    }

    // Set the default number of items to bring
    extractedFiltersParams.apiQueryParams =
      extractedFiltersParams.apiQueryParams +
      (extractedFiltersParams.apiQueryParams === "" ? "?" : "&") +
      "size=48";

    if (query.categories) {
      const categoryProducts = await reduxStore.dispatch(
        getCategory(query, extractedFiltersParams)
      );

      if (!categoryProducts && res) {
        res.statusCode = 404;
      }
    }

    if (query.q && !req) {
      await reduxStore.dispatch(getSearch(query, extractedFiltersParams));
      ready = true;
    }

    return {
      urlAsPath,
      extractedFiltersParams,
      layout: query.q ? "search" : "category",
      query,
      ready,
      currentUrl,
    };
  }

  async componentDidMount() {
    const { query } = this.props;
    if (query.q) {
      if (this.props.ready) {
        this.setState({
          ready: true,
        });
      } else {
        await this.props.getSearch(query, this.props.extractedFiltersParams);
        this.setState({
          ready: true,
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.state.ready && this.props.ready) {
      this.setState({
        ready: true,
      });
    }
  }

  render() {
    const {
      currentCategory,
      extractedFiltersParams,
      layout,
      query,
      currentUrl,
    } = this.props;
    if (!this.state.ready && query.q) {
      return <Loading height={100} />;
    }
    if (
      currentCategory &&
      (currentCategory.category || currentCategory.search)
    ) {
      return (
        <>
          <CatalogList
            extractedFiltersParams={extractedFiltersParams}
            layout={layout}
            query={query}
            currentUrl={currentUrl}
          />
        </>
      );
    }

    return <ErrorPage layout="404" />;
  }
}

List.pageLayout = "default";

export default withRouterPageLayout(
  connect(
    (state) => ({
      user: state.user,
      currentCategory: state.catalog.currentCategory,
    }),
    {
      getCategory,
      getSearch,
    }
  )(List)
);
